import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("code"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("relativeCode"),
            field: "Código de familiar",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("fatherLastName"),
            field: "Apellido paterno",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("motherLastName"),
            field: "Apellido materno",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("firstName"),
            field: "Primer nombre",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("secondName"),
            field: "Segundo nombre",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellidos y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("familyType"),
            field: "Tipo de familiar string",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("sex"),
            field: "Sexo string",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("income"),
            field: "Fecha de ingreso",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("bornDateVisibleShort"),
            field: "Fecha de nacimiento",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("weddingDate"),
            field: "Fecha de casamiento",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("familyAllowance"),
            field: "Asignación familiar string",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("assignmentDueDate"),
            field: "Fecha de vencimiento de la asignación",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("judicialRetention"),
            field: "Retención judicial string",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("disability"),
            field: "Incapacidad string",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("schoolingSingular"),
            field: "Escolaridad string",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.familyGroup],
        config: {
            headerName: getLocalizedString("schoolCertificateYear"),
            field: "Año del certificado escolar",
            filter: "agSetColumnFilter",
        }
    },
]